<template>
  <div class="flight-search-page">
    <tanitimMail ref="tanitimdialog" :servisTipi="3" :providers="itemsproviders" />
    <yetkidialog ref="yetkidialog" />
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel" />
    <snackbarcomp v-bind:mesaj="snackText" v-model="snackbar" v-bind:color="snackColor" />

    <provider-add-dialog v-model="dialogtedarikci" :session-header="sessionHeader" :providers="itemsproviders"
      :airline-list="itemsairlinelist" @added="refreshProviders" @edit="openEditDialog" @notify="showNotify" />


    <!-- Page Layout -->
    <v-card flat class="page-card">
      <v-layout row wrap>

        <!-- Toolbar -->
        <v-flex xs12>
          <v-toolbar class="page-toolbar" dark>
            <v-toolbar-title class="page-title">{{ $t('Search-Flight') }}</v-toolbar-title>
            <v-spacer />
            <v-btn flat class="supplier-btn" @click="tedarikcidialogac">
              <v-icon left>business</v-icon>
              <span class="hidden-sm-and-down">{{ $t('Supplier-Info') }}</span>
            </v-btn>
          </v-toolbar>
        </v-flex>

        <!-- Flight Search -->
        <ucusara @showList="showTickets($event)" @filterList="filterTicketList($event)" @setFlightType="setFlightType"
          @setisDomesticRT="setisDomesticRT($event)" @setCurrency="setCurrency($event)" />

        <!-- Flight List -->
        <ucuslist :ticketList="ticketList" :FlightType="FlightType" :isActive="ActiveType"
          :isDomesticRT="isDomesticRT" :currency="currentCurrency" />

        <!-- No Active Supplier Warning -->
        <v-flex xs12 pa-3 v-if="ActiveType === false">
          <v-alert type="warning" :value="true" outline class="supplier-alert">
            <v-layout align-center row>
              <v-flex>
                <span class="subheading font-weight-medium">{{ $t('supplier-warning') }}</span>
              </v-flex>
            </v-layout>
          </v-alert>
        </v-flex>

        <!-- Empty Results – Airline Provider Grid -->
        <v-flex xs12 pa-3 v-if="ticketList.length === 0">
          <v-card class="empty-results-card" elevation="1">
            <v-card-title primary-title class="pb-1">
              <div class="subheading grey--text text--darken-2">{{ $t('runner-v8') }}</div>
            </v-card-title>

            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6 sm6 md3 pa-2 v-for="airline in airlineLogos" :key="airline.name">
                  <v-card class="airline-logo-card" :class="{
                    'airline-logo-card--active': airline.active,
                    'airline-logo-card--inactive': !airline.active
                  }" elevation="1">
                    <v-card-text class="airline-logo-content text-xs-center pa-3">
                      <img :src="airline.src" :alt="airline.name" class="airline-logo-img" />
                      <div v-if="!airline.active" class="coming-soon-badge">{{ $t('coming-soon') }}</div>
                      <div v-if="airline.name === 'EasyGDS'">**EasyGDS {{ $t('Marka-Değişimi') }}</div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions class="pa-3">
              <v-btn color="primary" block large elevation="2" class="contact-btn" @click="irtibatDialog">
                {{ $t('CONTACT-US') }}
                <v-icon right>contact_mail</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from '@/components/app/customcomp/yetkidialog.vue';
import snackbarcomp from '@/components/app/customcomp/snackbarcomp';
import loadingcomp from '@/components/app/customcomp/loadingcomp';
import ucusara from '../comp/ucak/ucusara.vue';
import ucuslist from '../comp/ucak/ucuslistGuncel.vue';
import tanitimMail from '@/components/app/customcomp/tanitimMail.vue';
import helpers from '@/components/app/customcomp/helpers.js';
import ProviderAddDialog from './ProviderAddDialog.vue';
import flightSearchService from './flightSearchService';
import { applyFlightFilters } from './flightFilters';

export default {
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    ucusara,
    ucuslist,
    tanitimMail,
    ProviderAddDialog,
  },

  data() {
    return {
      // UI State
      dialogtedarikci: false,
      dialogtedarikciGuncelle: false,
      loadingvmodel: false,
      snackbar: false,
      snackColor: 'black',
      snackText: null,

      // Authorization
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },

      // Flight State
      FlightType: null,
      ActiveType: null,
      isDomesticRT: false,
      currentCurrency: 'TRY',
      ticketList: [],
      filterBackupTicketList: [],

      // Session (set dynamically after login)
      sessionHeader: { SessionId: null, SessionToken: null },

      // Company
      firmaBilgileri: null,
      bookingUsername: '',
      bookingPassword: '',

      // Providers
      itemsproviders: [],
      itemsairlinelist: [],
      guncellenecekTedarikci: {}
    };
  },

  computed: {
    airlineLogos() {
      const logos = [
        { name: 'TurkishAirlines', src: require('@/assets/images/thy.png'), active: true },
        { name: 'Ajet', src: require('@/assets/images/ajet.png'), active: true },
        { name: 'Pegasus', src: require('@/assets/images/pegasus.png'), active: true },
        { name: 'Turna', src: require('@/assets/images/turnacom.png'), active: true },

        { name: 'AirArabia', src: require('@/assets/images/airarabia.png'), active: false },
        { name: 'EasyGDS', src: require('@/assets/images/easygds.png'), active: false }
      ];

      if (process.env.VUE_APP_TARGET === 'couk') {
        logos.push({ name: 'Paximum', src: require('@/assets/images/paximum.png'), active: true });
      }

      return logos;
    }
  },

  methods: {
    // ── Notifications ─────────────────────────────────────────
    showNotify({ type, message }) {
      this.snackColor = type === 'success' ? 'success' : 'error';
      this.snackText = message;
      this.snackbar = true;
    },

    showError(message = 'İşlem başarısız oldu') {
      this.loadingvmodel = false;
      this.showNotify({ type: 'error', message });
    },

    // ── Provider Management ────────────────────────────────────
    async tedarikcidialogac() {
      this.dialogtedarikci = true;
      this.loadingvmodel = true;
      await Promise.all([this.refreshProviders(), this.loadAirlineList()]);
      this.loadingvmodel = false;
    },


    async refreshProviders() {
      try {
        const resp = await flightSearchService.getCredentials(this.$http, this.sessionHeader);
        const creds = (resp.body && resp.body.Credentials) || [];
        this.itemsproviders = creds
          .filter(c => c.ProviderType === 'Air')
          .map(c => ({
            Id: c.Id,
            Provider: c.Provider,
            ProviderType: c.ProviderType,
            ServiceUsername: c.ServiceUsername,
            ServicePassword: c.ServicePassword,
            ServiceSecurityKey: c.ServiceSecurityKey,
            OfficeId: c.OfficeId,
            url: c.Address
          }));
      } catch {
        this.showNotify({ type: 'error', message: 'Provider bilgileri alınamadı' });
      }
    },

    async loadAirlineList() {
      try {
        const credentials = JSON.parse(localStorage.getItem('credentials') || '{}');
        const resp = await flightSearchService.getAirlineList(this.$http, credentials.SirketKodu);
        this.itemsairlinelist = resp.body;
      } catch {
        // airline list is non-critical; fail silently
      }
    },

    openEditDialog(provider) {
      this.guncellenecekTedarikci = provider;
      this.dialogtedarikciGuncelle = true;
    },

    // ── Booking Initialization Chain ──────────────────────────
    async BookingKontrol() {
      const firmaOk = await this.firmaBilgileriGetir();
      if (!firmaOk) return;

      const ekUrunOk = await this.ekUrunGetir();
      if (!ekUrunOk) return;

      const agencyExists = await this.chkAgency();
      if (!agencyExists) {
        const added = await this.addAgency();
        if (!added) return;
      }

      await this.login();
    },

    async firmaBilgileriGetir() {
      this.loadingvmodel = true;
      try {
        const credentials = JSON.parse(localStorage.getItem('credentials') || '{}');
        const resp = await flightSearchService.getCompany(this.$http, credentials.SirketKodu);

        this.firmaBilgileri = {
          Name: credentials.CoperSirketAdi,
          City: resp.body.Il,
          District: resp.body.Ilce,
          Address: resp.body.Adres,
          Gsm: resp.body.Tel,
          Email: resp.body.Email,
          TaxOffice: resp.body.VergiDairesi,
          TaxNo: resp.body.VergiNo
        };

        if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
          this.showError('Firma Mail Adresi veya Vergi Numarası Bulunamadı');
          return false;
        }
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showError('Firma bilgileri alınamadı');
        return false;
      }
    },

    async ekUrunGetir() {
      this.loadingvmodel = true;
      try {
        const resp = await flightSearchService.checkExtraProduct(this.$http);
        const aktif = resp.body[3] && resp.body[3].Aktif;
        if (!aktif) {
          this.showError('Pazar Yeri Ürünü Bulunamadı');
          return false;
        }
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showError('Extra ürün bilgisi alınamadı');
        return false;
      }
    },

    async chkAgency() {
      this.loadingvmodel = true;
      try {
        const resp = await flightSearchService.checkAgency(
          this.$http,
          this.firmaBilgileri.Email,
          this.firmaBilgileri.TaxNo
        );
        if (resp.body.HasError) {
          this.loadingvmodel = false;
          return false;
        }
        this.bookingUsername = resp.body.Username;
        this.bookingPassword = resp.body.Password;
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showError('Ajans kontrolü yapılamadı');
        return false;
      }
    },

    async addAgency() {
      this.loadingvmodel = true;
      try {
        const resp = await flightSearchService.addAgency(this.$http, this.firmaBilgileri);
        if (resp.body.Username) {
          this.bookingUsername = resp.body.Username;
          this.bookingPassword = resp.body.Password;
        }
        this.loadingvmodel = false;
        return true;
      } catch {
        this.showError('Ajans eklenemedi');
        return false;
      }
    },

    async login() {
      this.loadingvmodel = true;
      try {
        const resp = await flightSearchService.login(this.$http, this.bookingUsername, this.bookingPassword);
        this.ActiveType = resp.body.Active;
        this.sessionHeader = {
          SessionId: resp.body.SessionId,
          SessionToken: resp.body.SessionToken
        };
        localStorage.setItem('bookingParams', JSON.stringify(resp.body));
        this.loadingvmodel = false;
      } catch {
        this.showError('Login başarısız oldu');
      }
    },

    // ── Ticket Filtering ──────────────────────────────────────
    filterTicketList(filter) {
      this.ticketList = applyFlightFilters(this.filterBackupTicketList || [], filter, this.currentCurrency);
    },

    showTickets(value) {
      this.ticketList = value;
      this.filterBackupTicketList = value;
    },

    setFlightType(value) {
      this.FlightType = value;
    },

    setisDomesticRT(value) {
      this.isDomesticRT = value;
    },

    setCurrency(value) {
      this.currentCurrency = value;
    },

    // ── Misc ──────────────────────────────────────────────────
    async irtibatDialog() {
      this.loadingvmodel = true;
      await this.refreshProviders();
      this.loadingvmodel = false;
      this.$refs.tanitimdialog.open(0);
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => { vm.prevRoute = from.path; });
  },

  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status === true) {
      this.BookingKontrol();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then(sonuc => {
          if (sonuc === true) {
            const dest = this.prevRoute || '/';
            window.open('#' + dest, '_self');
          }
        });
    }
  }
};
</script>

<style scoped>
/* ── Page ─────────────────────────────────────── */
.flight-search-page {
  background: #ffffff;
  min-height: 100vh;
}

.page-card {
  background: #ffffff !important;
}

/* ── Toolbar ──────────────────────────────────── */
.page-toolbar {
  background: linear-gradient(135deg, #1976D2, #1565C0) !important;
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.35) !important;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
}

.supplier-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  transition: background 0.2s ease;
}

.supplier-btn:hover {
  background: rgba(255, 255, 255, 0.15) !important;
}

/* ── Supplier Warning ─────────────────────────── */
.supplier-alert {
  border-radius: 10px !important;
  font-size: 15px;
}

/* ── Empty Results Card ───────────────────────── */
.empty-results-card {
  border-radius: 12px !important;
}

/* ── Airline Logo Cards ───────────────────────── */
.airline-logo-card {
  border-radius: 12px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: default;
  position: relative;
  overflow: hidden;
}

.airline-logo-card:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14) !important;
}

.airline-logo-card--active {
  border: 2px solid #43A047;
}

.airline-logo-card--inactive {
  border: 2px solid #e0e0e0;
  opacity: 0.75;
}

.airline-logo-content {
  min-height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.airline-logo-img {
  max-height: 50px;
  max-width: 80%;
  object-fit: contain;
}

/* ── Coming Soon Badge ────────────────────────── */
.coming-soon-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  background: #FF9800;
  color: #ffffff;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 10px;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

/* ── Contact Button ───────────────────────────── */
.contact-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  font-size: 15px;
  font-weight: 500;
}
</style>
